<template>
  <div>
    <public-mobile-menu v-if="!is_admin_route"></public-mobile-menu>
    <public-header-top v-if="!is_admin_route"></public-header-top>
    <public-header v-if="!is_admin_route"></public-header>

    <router-view></router-view>

    <div class="footer__klaviyo" v-if="!is_admin_route && !is_franchising_route && !is_contact_route">
      <div class="footer__klaviyo-inner footer__klaviyo-inner--desktop">
        <div class="klaviyo-form-W4UDbj"></div>
      </div>
      <div class="footer__klaviyo-inner  footer__klaviyo-inner--mobile">
        <div class="klaviyo-form-WUCWKq"></div>
      </div>
    </div>

    <public-footer v-if="!is_admin_route"></public-footer>
  </div>
</template>


<script>

import { SupabaseClient } from './models/SuperbaseClient'

export default {
  data(){
    return{

    }
  },
  mounted(){

    SupabaseClient.auth.getSession().then(({ data }) => {
      this.$store.commit('setAuthSession', data.session);
     // console.log("auth_session", this.auth_session)
    });

    SupabaseClient.auth.onAuthStateChange((_, _session) => {
      this.$store.commit('setAuthSession', _session);
    });

    console.log("is_franchising_route", this.is_franchising_route, "is_admin_route", this.is_admin_route)
  },
  computed:{
    is_admin_route(){
      return this.$route.path.includes("/admin")
    },
    is_franchising_route(){
      return this.$route.path.includes("franchising")
    },
    is_contact_route(){
      return this.$route.path.replace(/\/$/, "") === "/contact"
    },
    auth_session(){
      return this.$store.getters.auth_session;
    },
    user_email(){
      return this.$store.getters.auth_session && this.$store.getters.auth_session.user ? this.$store.getters.auth_session.user.email : null;
    }
  },
  methods:{

  }
}
</script>
